<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir anexo"
            @click.stop="confirmarExcluirAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoAnexo: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirAnexo() {
            this.$swal({
                title: 'Exclusão de Anexo',
                html: `Confirma a exclusão do anexo ${this.pagamentoAnexo.nomeArquivoOriginal}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirAnexo()
                }
            })
        },

        excluirAnexo() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .excluirAnexo({
                    pagamentoId: this.$route.params.pagamentoId,
                    pagamentoAnexoId: this.pagamentoAnexo.pagamentoAnexoId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
